import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import { ifProp, prop, ifNotProp } from 'styled-tools'
import colorsOptions from '../stories/fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../stories/fundamentals/text-styles/constants'

const SHAWDOW_OPACITY = 33

export const MenuLink = styled(Link)`
  ${ifProp('disabled', 'pointer-events: none;')}
  text-decoration: none;
  padding: 7px 12px;
  color: ${({ disabled, color }) =>
    disabled
      ? colorsOptions.greys['grey-40']
      : color || colorsOptions.greys['grey-100']};
  display: block;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  background: ${colorsOptions.greys.white};
  width: 100%;
  text-align: ${prop('textalignment', 'left')};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  &:hover {
    background: ${colorsOptions.greys['grey-20']};
  }
  @media (max-width: 767px) {
    padding: 15px 12px;
  }
  display: flex;
  justify-content: space-between;
`

export const SubmenusLink = styled.ul`
  padding: 0;
  margin: 0;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  &:not(:last-child) {
    margin-right: 16px;
  }
  li {
    list-style-type: none;
    text-align: left;

    ul {
      display: inline-block;
      padding: 0;
      margin: 0;
      position: absolute;
      top: 65px;
      right: 0;
      left: auto;
      width: 288px;
      border: 1px solid ${colorsOptions.greys['grey-20']};
      box-shadow: 3px 3px 3px
        ${colorsOptions.greys['grey-100']}${SHAWDOW_OPACITY};
      z-index: 1003;
      @media (max-width: 767px) {
        top: 40px;
        width: 289px;
      }

      &:after {
        position: absolute;
        right: 8px;
        top: -11px;
        width: 0;
        height: 0;
        content: '';
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid ${colorsOptions.greys['grey-20']};
      }

      &:before {
        position: absolute;
        right: 16px;
        top: -9px;
        width: 0;
        height: 0;
        content: '';
        border-style: solid;
        border-width: 0 10px 10px 10px;
        border-color: transparent transparent
          ${ifProp(
            'header',
            colorsOptions.greys['grey-60'],
            colorsOptions.greys.white
          )}
          transparent;
        z-index: 3;
      }
      &:hover {
        &:before {
          ${ifNotProp('header', 'border:none;')}
        }
      }

      li {
        list-style-type: none;
        border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
`

export const MenuLinks = styled.span`
  ${ifProp('disabled', 'pointer-events: none;')}
  text-decoration: none;
  justify-content: space-between;
  padding: 7px 12px;
  color: ${({ disabled, color }) =>
    disabled
      ? colorsOptions.greys['grey-40']
      : color || colorsOptions.greys['grey-100']};
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  background: ${colorsOptions.greys.white};
  text-align: ${ifProp('textalignment', prop('textalignment'), 'left')};
  width: 100%;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  height: 40px;
  border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
  &:hover {
    background: ${colorsOptions.greys['grey-20']};
  }
  @media (max-width: 767px) {
    padding: 15px 12px;
  }
`

export const Anchor = styled.a`
  color: ${colorsOptions.greys['grey-100']};
  border-radius: 40px;
  display: block;
  float: left;
  width: 40px;
  height: 40px;
  text-align: center;
  cursor: pointer;
  margin: 0 auto;
  letter-spacing: 1px;
  ${ifProp('disabled', 'pointer-events: none;')}
  ${({ isMobile }) =>
    !isMobile &&
    `
  background:${colorsOptions.greys.white};
  box-shadow: 0px 1px 5px 0px rgba(20, 26, 33, 0.2);`}
  &:hover {
    background: ${colorsOptions.greys['grey-20']};
  }
`

export const SubMenuBlock = styled.span`
  cursor: pointer;
  position: relative;
  ${({ top }) => top && `top: ${top}px;`}
  ul {
    list-style-type: none;
    padding: 0;
    margin: -10px 0 0;
    position: absolute;
    left: auto;
    right: -7px;
    min-width: 200px;
    border: 1px solid ${colorsOptions.greys['grey-20']};
    box-shadow: 3px 3px 3px ${colorsOptions.greys['grey-100']}${SHAWDOW_OPACITY};
    z-index: 99999999999;
    ${ifProp({ direction: 'up' }, 'bottom: 31px;', 'top:52px;')}

    &:after {
      position: absolute;
      right: 8px;
      width: 0;
      height: 0;
      content: '';
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;

      ${ifProp(
        { direction: 'up' },
        `
          bottom: -11px;
          border-top: 10px solid ${colorsOptions.greys['grey-20']};
        `,
        `
          top: -11px;
          border-bottom: 10px solid ${colorsOptions.greys['grey-20']};
        `
      )}
    }

    &:before {
      position: absolute;
      right: 8px;
      width: 0;
      height: 0;
      content: '';
      border-style: solid;
      z-index: 3;

      ${ifProp(
        { direction: 'up' },
        css`
          bottom: -9px;
          border-width: 10px 10px 0 10px;
          border-color: ${ifProp(
              'header',
              colorsOptions.greys['grey-60'],
              colorsOptions.greys.white
            )}
            transparent transparent transparent;
        `,
        css`
          top: -9px;
          border-width: 0 10px 10px 10px;
          border-color: transparent transparent
            ${ifProp(
              'header',
              colorsOptions.greys['grey-60'],
              colorsOptions.greys.white
            )}
            transparent;
        `
      )}
    }
    &:hover {
      &:before {
        ${ifNotProp('header', 'border:none;')}
      }
    }
    li {
      list-style-type: none;
      text-align: right;
      border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
      &:last-child {
        border-bottom: none;
      }
    }
    > span,
    a,
    li,
    button {
      border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
      height: 40px;
      display: flex;
      align-items: center;
      &:last-child {
        border-bottom: none;
      }
    }
  }
`
export const EditMenuBtn = styled.a`
  ${ifProp('disabled', 'pointer-events: none;')}
  color:${colorsOptions.greys['grey-100']};
  cursor: pointer;
  outline: none;
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  text-align: center;
  margin: 0 auto;
  letter-spacing: 1px;
`
export const SubMenuHeader = styled.li`
  background: ${colorsOptions.greys['grey-60']};
  color: ${colorsOptions.greys.white};
  padding: 7px 12px;
  font-weight: 800;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${ifProp('onClick', 'pointer', 'default')};
`
export const DrawerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`
